/*
This constants are useful to store authentication
client related details
*/

export const authClient = {
    // client_id: process.env.REACT_APP_CLIENT_ID,
    grant_type: process.env.REACT_APP_GRANT_TYPE,
    scope: process.env.REACT_APP_SCOPE
    // client_secret: process.env.REACT_APP_CLIENT_SECRET
}

// export const publicClient = {
//     client_id: process.env.REACT_APP_PUBLIC_CLIENT_ID,
//     grant_type: process.env.REACT_APP_PUBLIC_GRANT_TYPE,
//     client_secret: process.env.REACT_APP_PUBLIC_CLIENT_SECRET
// }

export const MARKETPLACE_COMMODITY_SIZE = 25

// Constants for Page Name
export const PAGE_NAME = {
    0: 'Air Waybill Stock Request',
    1: 'Air Waybill Stock Status',
    2: 'Archived Shipments',
    3: 'Carrier SPOT Offers',
    4: 'Claim Status',
    5: 'CPS IATAMSG',
    6: 'Create / Retrieve MAWB',
    7: 'Create / Review Auto Recurring Booking Template',
    8: 'Create / Review Booking',
    9: 'Create MAWB',
    10: 'Create Spreadsheet Booking',
    11: 'Damage Report Status',
    12: 'Delivery Declaration',
    13: 'Enter HAWB Info',
    14: 'Estimate Rate',
    15: 'File a Final Claim',
    16: 'File a Preliminary Claim',
    17: 'File Damage Report',
    18: 'Online Freight Payments',
    19: 'Pay Kargo',
    20: 'Piece Level Tracking',
    21: 'Print Shipping Label',
    22: 'Request Allotments',
    23: 'Review Current Bookings',
    24: 'Search Air Waybills',
    25: 'Search Available Space',
    26: 'Search Rates & Availability',
    27: 'Spot Rate Request',
    28: 'Spot Rate Retrieve',
    29: 'Track Shipments',
    30: 'View Allotments',
    31: 'View Carrier Schedules',
    32: 'View Customs Status',
    33: 'View Flight Status',
    34: 'Market Place'
}

/**
 * List of banned passwords that should not be accepted
 */
export const BANNED_PASSWORDS: string[] = [
    '11111111',
    '12345678',
    '1234567a',
    '1234567q',
    '1234abcd',
    '1234asdf',
    '1234qwer',
    '1234zxcv',
    '1q2w3e4r',
    '1qaz2wsx',
    '1qazxsw2',
    'abc12345',
    'password',
    'qazwsxed',
    'qwerty12',
    'qwertyui',
    'userid',
    'cps',
    'cargo',
    'portal',
    'service',
    'welcome',
    'system'
]
